import React, { useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
import "./../../HomePage/Faq/Faq.css";
const PccFaqMain = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);
  return (
    <div className="faqMainContainer">
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is a Police Clearance Certificate (PCC)?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              A PCC is an official document issued by the police or passport
              office confirming that you have no criminal record. It is required
              for overseas jobs, visas, migration, higher studies, and residence
              permits.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Who needs PCC Verification in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              You need PCC verification if you are applying for:
              <ul>
                <li> UAE / Qatar / Kuwait / Saudi Arabia / Oman visa</li>
                <li> Work Permit / Employment Visa</li>
                <li> PR / Immigration (Canada, Australia, New Zealand)</li>
                <li> Student Visa</li>
                <li> Long-term residence abroad</li>
                <li> Nursing, Security, and Government roles abroad</li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3> What documents are needed to apply for PCC in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              You will typically need:
              <ul>
                <li> Original Passport + Xerox</li>
                <li> Application form</li>
                <li> 2 Passport-size photos</li>
                <li> Address proof (Aadhaar, rental agreement)</li>
                <li> Offer letter / visa copy (for some countries)</li>
                <li> Old PCC (if applying again)</li>
              </ul>
              Requirements vary slightly depending on Passport Seva Kendra,
              Police Station, or Embassy.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does PCC verification take in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Processing time varies by issuing authority:
              <ul>
                <li>
                  {" "}
                  <b>Passport Office PCC:</b> 1–7 working days
                </li>
                <li>
                  {" "}
                  <b>Local Police PCC:</b> 3–10 days
                </li>
                <li>
                  {" "}
                  <b>Embassy PCC:</b> 7–25 days (depending on country)
                </li>
              </ul>
              A verification visit by police may be required for some
              applicants.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Do I need to visit the police station for PCC?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Not always.
              <br />
              For many, PCC is issued based on Passport Seva Kendra (PSK) police
              verification at home. You may need to visit the police station
              only if:
              <ul>
                <li> Address mismatch</li>
                <li> Pending verification</li>
                <li> Supporting document clarification</li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Can I apply for PCC if my address on passport is different?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes, but address mismatch may lead to additional verification,
              which takes more time. Some applicants may need to provide:
              <ul>
                <li> Rental agreement</li>
                <li> HR letter</li>
                <li> Electricity bill</li>
                <li> Gas connection</li>
              </ul>
              A good attestation agency can guide you through this.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How much does PCC Verification cost in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Costs vary depending on the authority and service type:
              <ul>
                <li> PSK PCC: ₹500–₹1,000</li>
                <li> Police Station PCC: ₹100–₹500</li>
                <li> Embassy PCC: ₹2,000–₹5,000 (varies by country)</li>
                <li> Agency Service Fees: ₹800–₹2,500</li>
              </ul>
              Charges vary if urgent or express service is required.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How do I track the status of my PCC? </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              You can track PCC status via:
              <ul>
                <li> Passport Seva Portal (for PSK)</li>
                <li> SMS from local police</li>
                <li> State police online portal</li>
                <li> Embassy website (for country-specific PCC)</li>
                <li> Updates from attestation service agencies</li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is PCC valid for all countries once issued?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              No.
              <br />
              PCC validity depends on the country and purpose:
              <ul>
                <li> Most countries accept PCC valid for 3–6 months</li>
                <li> Some GCC countries may need a fresh PCC</li>
              </ul>
              Always check the requirement for your destination.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Can an attestation or agency help with PCC from Bangalore?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes, agencies help with:
              <ul>
                <li>  Filling forms</li>
                <li> Booking appointments</li>
                <li> Documentation review</li>
                <li> Police verification guidance</li>
                <li> Embassy PCC assistance</li>
                <li> Updates until PCC is issued</li>
              </ul>
              They simplify the entire process and reduce delays.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default PccFaqMain;
